import TextField from "@material-ui/core/TextField";
import CopyKeyPairModal from "./copyKeyPairModal";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CreateReceiver = (props) => {
  const { t } = useTranslation();
  const [secretKey, setSecretKey] = useState("");
  const {
    receiverInfo,
    setAccountName,
    accountName,
    handleCreatedValidatorAddress,
  } = props;

  useEffect(() => {
    if (receiverInfo) {
      setSecretKey(receiverInfo.secret.toString(false));
    }
  }, [receiverInfo]);

  return (
    <div className="TableBg cardBg mt-30">
      <div className="ContHeader pendingTable">
        <h3>{t("Validator_Address")}</h3>
        <button
          className="btn btn-default CreateWalletBtn CreateWalletValidatorBtn"
          disabled={secretKey ? true : false}
          onClick={(e) => handleCreatedValidatorAddress()}
        >
          {t("Create")}
        </button>
      </div>
      <div className="validator_address">
        <>
          <div className="validator_address_input">
            <TextField
              disabled
              label={t("New_Secret_Key")}
              type="text"
              value={secretKey}
              fullWidth
            />
          </div>
          <div className="validator_address_input">
            <TextField
              label={t("Wallet_Name")}
              type="text"
              onChange={(e) => setAccountName(e.target.value)}
              value={accountName}
              fullWidth
            />
          </div>
        </>
      </div>
    </div>
  );
};
export default CreateReceiver;
